import { getStatusById } from '../getStatusById';
import { type TOrdersResponse } from '../../../redux/types/OrdersTypes';
import formatNumber from '../formatNumber';

export interface OrderModel {
  id: string;
  status: string;
  statusId: string;
  isSelectorStatusActive: boolean;
  card_number: string;
  bank: string;
  expected_income: string;
  real_income: string;
  temp_income?: string;
  date: string;
  fio?: string;
  time_left?: number;
  has_files?: boolean;
  integration_order: boolean,
  comments: Record<number, string>;
}

const mapOrders = (orders: TOrdersResponse[] | undefined): OrderModel[] => {
  return (
    orders?.map((item: TOrdersResponse) => ({
      id: item.id,
      status: getStatusById(item.status),
      statusId: item.status,
      isSelectorStatusActive: false,
      card_number: item.requisite.account_number,
      fio: item.requisite.fio,
      bank: item.requisite.bank.name,
      expected_income: String(formatNumber(item.expected_income, 2)),
      real_income: String(formatNumber(item.real_income, 2)),
      temp_income: String(formatNumber(item.temp_income || 0, 2)),
      date: item.create_dt,
      time_left: item.time_left,
      has_files: item.has_files,
      integration_order: item.integration_order,
      comments: item.comments
    })) ?? []
  );
};

export default mapOrders;
